export { default as ContentCard } from "./ContentCard";
export type { ContentCardProps, ContentCardRatio } from "./ContentCard.types";
